module.exports = __webpack_public_path__ + "static/media/b-logo-temp.bfe38654.svg";